<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input v-model="search.invoice_id"
                           class="form-control mr-sm-2"
                           type="text"
                           placeholder="บิลขาย TN"/>
                    &nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.customer"
                        :customLabel="customerLabel"
                        :options="customerOption"
                        :show-labels="false"
                        placeholder="ค้นหาลูกค้า"
                        track-by="id">
                    </multiselect>
                    <button type="button" class="btn btn-success"
                            @click="getCreditNoteTable(1)">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;
                    <button type="button" class="btn btn-primary"
                            :disabled="!checkbox_id"
                            @click="printCreditNotePDF(null)">
                        <icon name="print"></icon>
                        พิมพ์ใบลดหนี้หลายใบ
                    </button>
                </form>
            </div>
            <br/>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>#</th>
                    <th>เลขที่ใบลดหนี้</th>
                    <th>วันที่</th>
                    <th>ชื่อเซลล์</th>
                    <th>ลูกค้า</th>
                    <th>เลขที่ใบคืนสินค้า</th>
                    <th>ยอดคืนสินค้า</th>
                    <th>ผู้สร้างใบลดหนี้</th>
                    <th>พิมพ์ใบลดหนี้</th>
                    <th>ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in creditNoteTable">
                    <td>
                        <input type="checkbox" v-model="checkbox_id" :value="data.id"/>
                    </td>
                    <td>{{ data.credit_note_no }}</td>
                    <td>{{ data.date | moment('DD/MM/YYYY') }}</td>
                    <td>
                        {{ data.sale_return_product && data.sale_return_product.sale ? data.sale_return_product.sale.name : "-" }}
                    </td>
                    <td>
                        {{ data.sale_return_product && data.sale_return_product.customer ? data.sale_return_product.customer.customer_id + data.sale_return_product.customer.store_name : "-" }}
                    </td>
                    <td>{{ data.sale_return_product ? data.sale_return_product.cn_number : "-" }}</td>
                    <td>{{ data.sale_return_product ? data.sale_return_product.return_price : 0 | currency }}</td>
                    <td>{{ data.user ? data.user.name : '-' }}</td>
                    <td>
                        <button class="btn btn-primary" @click="printCreditNotePDF(data.id)" type="button">
                            <icon name="print"></icon>
                            พิมพ์ใบลดหนี้
                        </button>
                    </td>
                    <td>
                        <a @click="deleteConfirm(data.id)" type="button">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getCreditNoteTable(dataPaginate.current_page)">
        </vue-pagination>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_data">
            <delete-confirm-modal @submit="deleteData"></delete-confirm-modal>
        </b-modal>
    </div>
</template>

<script>
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";

export default {
    name: "CreditNoteList",
    components: {Loading, VuePagination, Multiselect, DeleteConfirmModal},
    data() {
        return {
            status_loading: 1,
            msg: '',
            delete_id: '',
            creditNoteTable: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            search: {
                sale: '',
                customer: '',
                invoice_id: '',
                product: ''
            },
            checkbox_id: [],
            customerOption: [],
        }
    },
    computed: {
        ...mapState({
            optionProduct: state => {
                return state.Products.product_all;
            },
        })
    },
    created() {
        this.getCreditNoteTable(1);
        this.getCustomerAll();
    },
    methods: {
        deleteConfirm(id) {
            this.delete_id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteDataModal() {
            this.$refs.delete_data.hide();
        },
        deleteData(value) {
            if (value) {
                this.$store.dispatch("SaleReturnProduct/deleteCreditnote", this.delete_id).then(() => {
                    this.getCreditNoteTable(1);
                    this.hideDeleteDataModal();
                }).catch(() => {
                    comsole.log('ลบไม่รายการสำเร็จ');
                })
            } else {
                this.hideDeleteDataModal();
            }
        },
        productLabel(option) {
            return `${option.sku} - ${option.short_name}`
        },
        customerLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(res => {
                this.customerOption = res;
            });
        },
        getCreditNoteTable(page) {
            let data = {
                customer_id: this.search.customer ? this.search.customer.id : '',
                invoice_id: this.search.invoice_id,
            }
            this.$store.dispatch("SaleReturnProduct/getCreditNote", {page, data}).then(res => {
                this.creditNoteTable = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to,
                };
            })
        },
        printCreditNotePDF(id) {
            this.showLoadingModal();
            this.status_loading = 1;
            this.msg = 'กรุณารอสักครู่';
            if (id) {
                this.$store.dispatch("SaleReturnProduct/printCreditNotePDF", id).then(url => {
                    if (url) {
                        window.open(url, '_blank')
                        this.hideLoadingModal();
                    } else {
                        this.status_loading = 3;
                        this.msg = 'ออกเอกสารไม่สำเร็จ';
                    }
                }).catch(err => {
                    //console.log(err);
                    this.status_loading = 3;
                    this.msg = 'ออกเอกสารไม่สำเร็จ';
                })
            } else {
                let id = this.checkbox_id.toString();
                this.$store.dispatch("SaleReturnProduct/printCreditNotePDF", id).then(url => {
                    if (url) {
                        window.open(url, '_blank')
                        this.hideLoadingModal();
                    } else {
                        this.status_loading = 2;
                        this.msg = 'ออกเอกสารไม่สำเร็จ';
                    }
                }).catch(err => {
                    //console.log(err);
                    this.status_loading = 3;
                    this.msg = 'ออกเอกสารไม่สำเร็จ';
                })
            }
        },
    },
}
</script>

<style scoped>
.select {
    border: 0
}
</style>
